export class ApiError extends Error {
  status: number;
  requestId?: string;
  /**
   * The server's `details` payload (AppError's third argument). Lets a caller
   * react to a specific refusal — e.g. the customer identity-change guard asks
   * the staff member to confirm and retry — instead of only showing the message.
   */
  details?: Record<string, unknown> | null;

  constructor(
    message: string,
    status: number,
    requestId?: string,
    details?: Record<string, unknown> | null
  ) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.requestId = requestId;
    this.details = details ?? null;
  }
}
